import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  SvgIcon,
  Avatar,
  Chip,
  InputBase,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  useTheme,
  ListItemText,
  ListSubheader,
  Grid,
  Card,
  Button,
  List,
  ListItem,
  ListItemButton,
  Icon,
  FormControl,
  Select,
  OutlinedInput,
  Popover,
} from "@mui/material";
import {
  Menu as MenuIcon,
  GppGoodOutlined as GppGoodOutlinedIcon,
  DashboardOutlined as DashboardOutlinedIcon,
  NotificationsOutlined as NotificationsOutlinedIcon,
  Height,
  Search as SearchIcon,
} from "@mui/icons-material";
import { ArrowLeftIcon, SearchOffOutlinedIcon } from "@/icons";
import profile from "../../assets/img/profile.png";
import robort from "../../assets/img/robort.svg";
import {
  styled,
  alpha,
  createTheme,
  ThemeProvider,
} from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import router from "@/router";
import menuItems from "./menulist";
import DialogForm from "@/components/modal/DialogForm";
import { useHotkeys } from "react-hotkeys-hook";
import { useDispatch } from "react-redux";
import { roleTypeLogin } from "@/slices/slices_/employeeSlice";
import { handleUnauthorizedError } from "@/utils/authUtils";
import CustomAlert from "../alert/CustomAlert";
import { useLazyFetchLogoQuery } from "@/api/services/Settings/organization/Organization";
import { toast } from "@/components/toastify";
import CommonDataTable from "../dataTableComponents/NewDatatable";
import Loader from "@/components/loader";
import IdCardViewer from "@/components/common/IdCardViewer";
import headerIdCard from "@/assets/images/header_id_card.png";
import axios from "axios";
import {
  useGetSwipeDetailsQuery,
  useLazyGetSwipeDetailsQuery,
  useLazyGetSwipeworkHoursQuery,
} from "@/api/services/attendance/regularization/EmployeeRegularization";
import dayjs from "dayjs";
import moment from "moment";
import { useLazyGetImageQuery } from "@/api/services/profile/profile_/FetchImageApi";
import { useFetchProfiletDetailsQuery } from "@/api/services/profile/profile_/ProfileApi";

const drawerWidth = 85;
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "30px",
  backgroundColor: "#E9E9E9",
  border: "1px solid black",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledIynputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
    margin: "-4px",
  },
}));

const listItemStyles = (theme) => ({
  borderRadius: 2,
  border: "1px solid #E9E9E9",
  backgroundColor: "#FAFAFA",
  color: "inherit",
  mb: 1,
  paddingY: "2px",

  "&:hover": {
    backgroundColor: theme.palette.BudgieThemeColor.Primary[500],
    borderColor: theme.palette.BudgieThemeColor.Primary[1000],
  },
  // "&.Mui-selected, &.Mui-selected:hover": {
  //   backgroundColor: theme.palette.BudgieThemeColor.Primary[500],
  //   borderColor: theme.palette.BudgieThemeColor.Primary[1000],
  // },
});

const themeinput = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          padding: 0,
        },
        input: {
          padding: 0,
        },
      },
    },
  },
});

const AppBarComponent = ({ handleDrawerToggle, loaderval }) => {
  const location = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchmodal, setSearchModal] = useState(false);
  const [searchlist, setSearchList] = useState([]);
  const [tabtext, setTabText] = useState(null);
  const [orgmodal, setOrgModal] = useState(false);
  const [orgvalue, setOrgValue] = useState(null);
  const [orglogo, setOrgLogo] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [swipemodal, setSwipeModal] = useState(false);
  const [calculatedProductiveProgress, setCalculatedProductiveProgress] =
    useState(0);
  const [calculatedOfficeProgress, setCalculatedOfficeProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState("");
  const [officeHoursRemaining, setOfficeHoursRemaining] = useState("");
  const [expectedHoursFormatted, setExpectedHoursFormatted] =
    useState("08h 00m 00s");
      const [workhoursDetails, { data: swipeWorkHoursData }] =
    useLazyGetSwipeworkHoursQuery();

  const [fetchImage] = useLazyGetImageQuery();
  const [fetchlogo] = useLazyFetchLogoQuery();

  const { data: profileDetails = [], refetch } = useFetchProfiletDetailsQuery();
  const [images, setImages] = useState({ banner: null, profile: null });

  const [placeholder, setPlaceholder] = useState("");

  const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));

  const iconRef = useRef(null);
  const [openPopover, setOpenPopover] = useState(false);
  const closeTimer = useRef(null);

  const showIdCard = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    setOpenPopover(true);
  };

  const hideIdCard = () => {
    closeTimer.current = setTimeout(() => {
      setOpenPopover(false);
    }, 120);
  };

  const fileName = loginDetails?.userDetails?.idCard?.fileName || null;
  const folderName = loginDetails?.userDetails?.idCard?.folderName || null;

  const phrases = [
    "Search anything (Press Ctrl + F)...",
    "Try e.g.Leave, Attendance, HelpDesk...",
    "Quick access to features and screens...",
    "Find employees, requests, or records...",
    "Type a keyword or use shortcuts to navigate...",
  ];

  let currentPhraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  useEffect(() => {
    const type = () => {
      const currentPhrase = phrases[currentPhraseIndex];

      if (isDeleting) {
        setPlaceholder(currentPhrase.substring(0, charIndex - 1));
        charIndex--;
      } else {
        setPlaceholder(currentPhrase.substring(0, charIndex + 1));
        charIndex++;
      }

      if (!isDeleting && charIndex === currentPhrase.length) {
        setTimeout(() => (isDeleting = true), 1000);
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
      }

      setTimeout(type, isDeleting ? 50 : 100);
    };

    type();
  }, []);
  const searchInput = useRef();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    localStorage.removeItem("empType");
    setAnchorEl(null);
  };

  useHotkeys(
    "ctrl+f",
    (e) => {
      e.preventDefault();
      setSearchModal(!searchmodal);
    },
    { enabled: !swipemodal, enableOnFormTags: true },
  );

  useHotkeys(
    "ctrl+s",
    (e) => {
      e.preventDefault();
      handleSwipeDetails();
    },
    { enabled: !searchmodal, enableOnFormTags: true },
  );

  // profile image
  useEffect(() => {
    const fetchProfileImages = async () => {
      try {
        if (profileDetails) {
          const profileUrl = await fetchImage({
            folderName: profileDetails?.data?.profileImage?.folderName,
            fileName: profileDetails?.data?.profileImage?.fileName,
          }).unwrap();

          setImages((prevImages) => ({
            ...prevImages,
            profile: profileUrl,
          }));
        }
      } catch (error) {
        console.error("Error fetching profile image:", error);
      }
    };
    if (profileDetails?.data?.profileImage?.folderName) {
      fetchProfileImages();
    }
  }, [profileDetails]);

  useEffect(() => {
    if (searchmodal && searchInput.current) {
      searchInput?.current.focus();
    }
  }, [searchmodal]);

  // Close any open menus when the route changes
  useEffect(() => {
    if (anchorEl) setAnchorEl(null);
    if (submenuAnchorEl) setSubmenuAnchorEl(null);
  }, [location.pathname]);

  const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));

  const localData = localStorageData?.userDetails;
  const loginId = localData?.empId;
  const menuss = localData?.permission;
  // const roles = localData.roles;
  const orgDetails = localData?.activeOrganization;
  const roles = orgDetails?.roleDetails;
  const orgTypes = localData?.organizationAccess;

  const [submenuAnchorEl, setSubmenuAnchorEl] = React.useState(null);
  const submenuopen = Boolean(submenuAnchorEl);

  const [triggerSwipeDetails, { data: quickAddList = [], isLoading }] =
    useLazyGetSwipeDetailsQuery();
  const rowData = quickAddList?.data || [];

  // const roles=["Employee","Super Admin","Payroll Super Admin","Travel Desk","Business Head","Travel Accounts"];

  useEffect(() => {
    logofetch();
  }, []);

  const logofetch = async () => {
    const logo = orgDetails?.logo;
    if (typeof logo !== "string" || logo.trim() === "") {
      console.log("No valid logo to fetch.");
      return;
    }
    try {
      const logoUrl = await fetchlogo(logo).unwrap();
      setOrgLogo(logoUrl);
    } catch (error) {
      console.log("Error fetching logo:", error);
    }
  };

  const handleSubmenuOpen = (event) => {
    setSubmenuAnchorEl(event.currentTarget); // Opens submenu on click of "Login As"
  };
  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null); // Closes the submenu
    setAnchorEl(null);
  };

  const handleLogout = () => {
    toast("success", "Logged out successfully");

    setTimeout(() => {
      handleUnauthorizedError();
    }, 1000);
  };

  const handlerole = async (val) => {
    handleSubmenuClose();
    const credentials = {
      type: "Role",
      value: val,
    };
    // window.location.reload();
    if (val != localData?.roleType) {
      try {
        loaderval(true);
        const result = await dispatch(roleTypeLogin(credentials)).unwrap(); // unwrap gets clean payload
        let localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
        let localData = localStorageData.userDetails;
        let menuList = localData.permission;
        setTimeout(() => {
          if (menuList.length > 0) {
            navigate(menuList[0].path);
          } else {
            navigate("/Dashboard");
          }
        }, 500);
      } catch (error) {
        console.error("Login failed:", error);
        // toast("error", "Failed try again");
      } finally {
        loaderval(false);
      }
    }
  };

  const url = location.pathname;

  const protectedRoutes = router.routes.find(
    (route) => route.path === "/",
  ).children;

  const findMatchedSubmenu = (items, currentPath) => {
    if (!Array.isArray(items) || items.length === 0) {
      return { submenu: [], text: "" };
    }
    for (const item of items) {
      // Check if the main path matches and has a submenu
      if (item.path === currentPath && item.submenu) {
        // setTabText(item.text);
        return { submenu: item.submenu, text: item.text };
        // return item.submenu;
      }

      // Check if the submenu contains the currentPath
      if (item.submenu) {
        const matchedSubItem = item.submenu.some(
          (subItem) => subItem.path === currentPath,
        );
        if (matchedSubItem) {
          // setTabText(item.text);
          return { submenu: item.submenu, text: item.text };
          // return item.submenu;
        }
      }
    }
    return { submenu: [], text: "" }; // Return empty array if no match is found
    // return []; // Return empty array if no match is found
  };

  const matchedItem = findMatchedSubmenu(menuss, url);

  const handleSearch = () => {
    searchInput.current.value = "";
    setSearchModal(!searchmodal);
    setSearchList([]);
  };

  const flattenMenuItems = (items) => {
    const flatItems = [];
    const flatten = (item) => {
      if (item?.submenu?.length > 0) {
        item.submenu.forEach((val) => {
          flatItems.push({ text: val.text, path: val.path, main: item.text });
        });
      } else {
        flatItems.push({ text: item.text, path: item.path });
      }
    };
    items.forEach(flatten);
    return flatItems;
  };

  const handleSearchBar = (val) => {
    if (val.trim() === "") {
      setSearchList([]);
      return;
    }
    const allItems = flattenMenuItems(menuss);
    // const allItems = flattenMenuItems(menuItems);
    // const matches = allItems.filter((item) => item.text?.toLowerCase().includes(val.toLowerCase()) );

    const matches = allItems.filter((item) => {
      const searchValue = val.toLowerCase();
      return (
        item.main?.toLowerCase().includes(searchValue) ||
        item.text?.toLowerCase().includes(searchValue)
      );
    });

    // setSearchList(matches);
    GroupedList(matches);
  };

  const GroupedList = (menus) => {
    // Group items by `main` or without `main`
    const groupedItems = menus.reduce((acc, item) => {
      if (item.main) {
        if (!acc[item.main]) acc[item.main] = [];
        acc[item.main].push(item);
      } else {
        if (!acc[item.text]) acc[item.text] = [];
        acc[item.text].push(item);
      }
      return acc;
    }, {});

    setSearchList(groupedItems);
  };

  const handlechangeOrg = (e) => {
    setOrgModal(!orgmodal);
    setOrgValue(e.target.value);
  };

  const handleOrgType = async () => {
    // console.log(e.target.value);
    const credentials = {
      type: "Organization",
      value: orgvalue,
    };
    try {
      const result = await dispatch(roleTypeLogin(credentials)).unwrap(); // unwrap gets clean payload
      let localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
      let localData = localStorageData.userDetails;
      let menuList = localData.permission;
      setTimeout(() => {
        let urlcheck = window.location.hash.split("/")[1];

        // if(urlcheck=="payroll"){
        //   navigate("/payroll");
        // }else{
        if (menuList.length > 0) {
          navigate(menuList[0].path);
        } else {
          navigate("/Dashboard");
          // }
        }
        // Force a page reload after navigation to ensure fresh data
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }, 200);

      console.log("Changed role:", localStorageData);
    } catch (error) {
      console.error("Login failed:", error);
      toast("error", error);
    }
    setOrgModal(!orgmodal);
  };

  const handleSwipeDetails = () => {
    setSwipeModal(!swipemodal);

    // First API call - workhoursDetails
    workhoursDetails({ empID: loginId, dateObj: dayjs().format("YYYY-MM-DD") })
      .then((response) => {
        const fullDayTime = response?.data?.data?.fulldayTime || "08:00";
        const inTime = response?.data?.data?.inTime || "----";
        const outTime = response?.data?.data?.outTime || "----";

        const [workHours, workMinutes] = fullDayTime.split(":").map(Number);
        const fullWorkingHours = workHours + workMinutes / 60;

        return triggerSwipeDetails({ empID: loginId }).then((swipeResponse) => {
          return { fullWorkingHours, inTime, outTime, swipeResponse };
        });
      })
      .then(({ fullWorkingHours, inTime, outTime, swipeResponse }) => {
        if (
          swipeResponse?.data?.data &&
          Array.isArray(swipeResponse.data.data)
        ) {
          const swipeData = [...swipeResponse.data.data];

          // Sort by LogDateTime to get chronological order
          swipeData.sort(
            (a, b) => new Date(a.LogDateTime) - new Date(b.LogDateTime),
          );

          if (swipeData.length > 0) {
            const inTimes = swipeData.filter(
              (item) => item.Direction?.toLowerCase() === "in",
            );
            const outTimes = swipeData.filter(
              (item) => item.Direction?.toLowerCase() === "out",
            );

            if (inTimes.length > 0) {
              const firstInTime = new Date(inTimes[0].LogDateTime);
              const lastEntry = swipeData[swipeData.length - 1];
              const isCurrentlyIn = lastEntry.Direction?.toLowerCase() === "in";

              // Parse scheduled times from API
              const [schedInHour, schedInMin] = inTime.split(":").map(Number);
              const [schedOutHour, schedOutMin] = outTime
                .split(":")
                .map(Number);

              // Create scheduled time objects for today
              const today = new Date();
              const scheduledInTime = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                schedInHour,
                schedInMin,
              );
              const scheduledOutTime = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                schedOutHour,
                schedOutMin,
              );

              // Use scheduled IN time if employee came early, otherwise use actual IN time
              const effectiveInTime =
                firstInTime < scheduledInTime ? scheduledInTime : firstInTime;

              // Helper function to format hours to HH:MM:SS
              const formatHoursToHMS = (hours) => {
                const totalSeconds = Math.floor(hours * 3600);
                const h = Math.floor(totalSeconds / 3600);
                const m = Math.floor((totalSeconds % 3600) / 60);
                const s = totalSeconds % 60;
                return `${h.toString().padStart(2, "0")}h ${m.toString().padStart(2, "0")}m ${s.toString().padStart(2, "0")}s`;
              };

              // Calculate actual total office time from effective IN time
              let totalOfficeTime;
              let lastOutTime;
              if (isCurrentlyIn) {
                // Person is still IN - calculate from effective IN to current time
                const currentTime = new Date();
                totalOfficeTime =
                  (currentTime - effectiveInTime) / (1000 * 60 * 60);
               
              } else {
                // Person is OUT - calculate from effective IN to last OUT time
                if (outTimes.length > 0) {
                  lastOutTime = new Date(
                    outTimes[outTimes.length - 1].LogDateTime,
                  );
                  totalOfficeTime =
                    (lastOutTime - effectiveInTime) / (1000 * 60 * 60);
                  
                } else {
                  totalOfficeTime = 0;
                }
              }

              // STEP 1: Fetch shift time from working API and define in variable
              const shiftTimeFromAPI = fullWorkingHours; // 9 hours from API
             

              // STEP 2: Minus 1 hour and define in variable
              const expectedProductiveHours = shiftTimeFromAPI - 1; // 8 hours
              

              // STEP 3: Calculate IN time based on shift time with only IN time
              let actualProductiveTime = 0;

              if (isCurrentlyIn) {
                // Person is currently IN - calculate from effective IN to current time
                const currentTime = new Date();
                actualProductiveTime =
                  (currentTime - effectiveInTime) / (1000 * 60 * 60);
                
              } else {
                // Person is OUT - calculate from first IN to last OUT
                if (outTimes.length > 0) {
                  const lastOutTime = new Date(
                    outTimes[outTimes.length - 1].LogDateTime,
                  );
                  actualProductiveTime =
                    (lastOutTime - effectiveInTime) / (1000 * 60 * 60);
                 
                 
                } else {
                  actualProductiveTime = 0;
                }
              }

              let totalBreakTime = 0;
              for (let i = 0; i < outTimes.length; i++) {
                const outTime = new Date(outTimes[i].LogDateTime);
                const nextInTime = inTimes[i + 1]
                  ? new Date(inTimes[i + 1].LogDateTime)
                  : null;

                if (nextInTime) {
                  const breakDuration =
                    (nextInTime - outTime) / (1000 * 60 * 60);
                  totalBreakTime += breakDuration;
                
                }
              }

              const finalProductiveTime = Math.max(
                0,
                actualProductiveTime - totalBreakTime,
              );
             

              const productiveProgress =
                (finalProductiveTime / expectedProductiveHours) * 100;
              const calculatedProgress = Math.min(
                100,
                Math.max(0, Math.round(productiveProgress)),
              );

             
              // Format for display
              const productiveTimeFormatted =
                formatHoursToHMS(finalProductiveTime);
              const expectedHoursDisplay = formatHoursToHMS(
                expectedProductiveHours,
              );

              // Office hours progress (separate calculation)
              const officeHoursProgress = Math.min(
                100,
                Math.max(
                  0,
                  Math.round((totalOfficeTime / fullWorkingHours) * 100),
                ),
              );

              // Update state with calculated progress
              setCalculatedProductiveProgress(calculatedProgress);
              setCalculatedOfficeProgress(officeHoursProgress);
              setTimeRemaining(productiveTimeFormatted);
              setExpectedHoursFormatted(expectedHoursDisplay);

              // Calculate expected out time for office hours (9 hours total)
              const officeExpectedOutTime = new Date(effectiveInTime);
              officeExpectedOutTime.setHours(
                officeExpectedOutTime.getHours() + 9,
              );
              // Add 1 minute for display only
              const displayOutTime = new Date(officeExpectedOutTime);
              displayOutTime.setMinutes(displayOutTime.getMinutes() + 1);

              // Calculate remaining work hours
              const remainingWorkHours = Math.max(
                0,
                fullWorkingHours - totalOfficeTime,
              );

              const officeHoursRemainingText = `Remaining: ${formatHoursToHMS(remainingWorkHours)} / Expected out Time: ${displayOutTime.toLocaleTimeString("en-US", { hour12: false, hour: "2-digit", minute: "2-digit" })}`;

              setOfficeHoursRemaining(officeHoursRemainingText);
            }
          }
        }
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };

  // const rows = rowDetails?.data || [];
  const columns = [
    // { field: "EmployeeCode", headerName: "Employee No", flex: 1 },
    // { field: "EmployeeName", headerName: "Employee Name", flex: 1 },
    // {
    //   field: "DownloadDate",
    //   headerName: "Date",
    //   flex: 1,
    //   // renderCell: (params) => dayjs(params.LogDateTime).format("YYYY-MM-DD"),
    //   renderCell: (params) => moment(params.row.DownloadDate).format("DD-MM-YYYY"),
    // },

    {
      field: "LogDateTime",
      headerName: "IN/OUT Time",
      flex: 1,
      renderCell: (params) => dayjs(params.value).format("HH:mm:ss"),
    },
    // { field: "DeviceName", headerName: "Door/Address", flex: 1 },
    {
      field: "DeviceName",
      headerName: "Door/Address",
      flex: 1,
      renderCell: (params) => {
        const value = params.value || "";
        const formatted = value
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase());
        return formatted;
      },
    },

    {
      field: "Direction",
      headerName: "IN/OUT",
      flex: 1,
      renderCell: (params) => {
        {
          const value = params.value || "";
          return value.toUpperCase();
        }
      },
    },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - (${drawerWidth}px + 44px))` },
          marginRight: { xs: 0, sm: "24px" },
          // borderRadius: 30,
          // height: "auto",
          backgroundColor: "#fdf9f6",
          color: "black",
          zIndex: 20,
          paddingRight: 0,
          boxShadow: "none",
        }}
      >
        <Box
          sx={{
            marginTop: "8px",
            marginBottom: "10px",
            height: "46px",
            backgroundColor: "white",
            borderRadius: 30,
            boxShadow: `0px 4px 9px 2px  #E9E9E980`,
          }}
        >
          <Box sx={{ padding: 0, display: "flex" }}>
            <IconButton
              color="default"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
              sx={{ mr: 0.5, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>

            <Box
              sx={{
                padding: "3px",
                borderRadius: "32px",
                background: "linear-gradient(270deg, #FFE9DA 0%, #FFFFFF 100%)",
                display: "flex",
                alignItems: "center",
                mr: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "32px",
                  backgroundColor: "#FDF9F6",
                }}
              >
                <Avatar
                  src={orglogo}
                  sx={{
                    "& img": {
                      objectFit: "contain",
                    },
                  }}
                />
                <Typography
                  sx={{
                    display: { xs: "none", sm: "block" },
                    alignContent: "center",
                    px: 1,
                    // paddingY: "8px",
                    height: "100%",
                    color: "#214A32",
                  }}
                  variant="h6"
                  noWrap
                >
                  {orgDetails?.organizationDetail}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                gap: 2,
                justifyContent: "space-between",
              }}
            >
              {/* Search Box - Now takes available space */}
              <Box sx={{ flexGrow: 1, maxWidth: { sm: "600px", md: "800px" } }}>
                <TextField
                  id="standard-start-adornment"
                  size="small"
                  placeholder={placeholder}
                  fullWidth
                  onClick={handleSearch}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        sx={{ paddingLeft: "5px" }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontWeight: "bold",
                            mr: 1,
                          }}
                        >
                          Ctrl + F
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    borderRadius: "32px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "32px",
                      border: "1px solid #E9E9E9",
                      backgroundColor: "#FAFAFA",
                      padding: "0px",
                      height: "32px",
                      "& input": {
                        paddingRight: "40px", // Make space for the end adornment
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E9E9E9",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E9E9E9",
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "32px",
                      borderColor: "#E9E9E9",
                    },
                  }}
                />
              </Box>

              {/* Right-aligned elements */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ alignContent: "center" }}>
                  <FormControl
                    sx={{
                      width: {
                        xs: "100px",
                        sm: "130px",
                        md: "200px",
                      },
                      maxWidth: "200px",
                    }}
                  >
                    <Select
                      value={orgDetails?.organizationCode}
                      onChange={handlechangeOrg}
                      displayEmpty
                      input={<OutlinedInput />}
                      placeholder={"Select Organization"}
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        height: "32px",
                        borderRadius: "8px",
                        width: "100%",
                      }}
                      renderValue={(selected, orgvalue) => {
                        if (!selected) {
                          return (
                            <Typography sx={{ color: "rgba(0, 0, 0, 0.54)" }}>
                              Select Organisation
                            </Typography>
                          );
                        }
                        const selectedOrg = orgTypes.find(
                          (item) => item.organizationCode === selected
                        );
                        return selectedOrg
                          ? selectedOrg.organizationDetail
                          : "";
                      }}
                    >
                      {orgTypes?.map((item, index) => (
                        <MenuItem value={item.organizationCode}>
                          {item.organizationDetail}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <IconButton
                    size="large"
                    aria-label="show 4 new mails"
                    color="inherit"
                    sx={{ padding: "4px" }}
                  >
                    <NotificationsOutlinedIcon />
                  </IconButton>
                </Box> */}
                {fileName && folderName && (
                  <Box
                    sx={{ display: { xs: "none", md: "flex" } }}
                    onMouseEnter={showIdCard}
                    onMouseLeave={hideIdCard}
                  >
                    <Box
                      component="img"
                      src={headerIdCard}
                      alt="ID Card Thumbnail"
                      ref={iconRef}
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        cursor: "pointer",
                        objectFit: "cover",
                      }}
                    />

                    <Popover
                      open={openPopover}
                      anchorEl={iconRef.current}
                      onClose={() => setOpenPopover(false)}
                      disableRestoreFocus
                      keepMounted
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      PaperProps={{
                        onMouseEnter: showIdCard,
                        onMouseLeave: hideIdCard,
                        sx: {
                          padding: 0,
                          borderRadius: "10px",
                          marginTop: "10px",
                        },
                      }}
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <IdCardViewer
                        fileName={fileName}
                        folderName={folderName}
                      />
                    </Popover>
                  </Box>
                )}

                <Box
                  sx={{
                    padding: "3px",
                    marginLeft: "5px",
                    borderRadius: "32px",
                    background: "linear-gradient(135deg, #FFE9DA, #FFFFFF)",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "29px",
                      backgroundColor: "white",
                      cursor: "pointer",
                    }}
                    onClick={handleClick}
                  >
                    <Typography
                      sx={{
                        alignContent: "center",
                        display: { xs: "none", sm: "block" },
                        paddingX: "4px",
                      }}
                      variant="h6"
                      noWrap
                    >
                      {localData.firstName}
                    </Typography>
                    <IconButton
                      sx={{ p: 0 }}
                      aria-controls={open ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <Avatar
                        src={images?.profile ? images?.profile : profile}
                        sx={{
                          "& img": {
                            objectFit: "contain",
                          },
                        }}
                        alt={loginDetails?.userDetails?.firstName}
                      />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* {matchedItem.submenu?.length > 0 &&(
              <Index  tabs={matchedItem.submenu} tabtitle={matchedItem.text}/>
              )} */}
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          // onClick={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                // overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: theme.palette.primary.main, // Scroll thumb color
                  borderRadius: "999px",
                },
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          disablePortal
          disableScrollLock
          disableAutoFocus
          disableEnforceFocus
        >
          {/* <MenuItem onClick={handleClose}> */}
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              width: "100%",
              color: `${theme.palette.BudgieThemeColor.Success[700]}`,
            }}
            onClick={handleClose}
            color={"primary"}
          >
            {" "}
            {/* Nirmal Kumar */}
            {localData.firstName}
          </Typography>
          {/* </MenuItem> */}
          {/* <MenuItem onClick={handleClose}> */}
          <Typography
            variant="caption"
            mb={1}
            sx={{
              display: "block",
              textAlign: "center",
              width: "99%",
              // paddingX: 3,
            }}
          >
            {" "}
            {localData.designation}
          </Typography>
          {/* </MenuItem> */}
          <Divider variant="middle" />
          <MenuItem>
            <ListItemIcon></ListItemIcon>
            <Typography
              variant="h6"
              sx={{
                width: "100%",
                color: `${theme.palette.BudgieThemeColor.Success[700]}`,
              }}
              color={"primary"}
            >
              {localData.roleType}
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={handleSubmenuOpen}
            aria-controls={submenuopen ? "accounts-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={submenuopen ? "true" : undefined}
          >
            <ListItemIcon>
              <ArrowLeftIcon />
            </ListItemIcon>
            Login As
          </MenuItem>
          <MenuItem onClick={handleSwipeDetails}>
            <ListItemIcon></ListItemIcon>
            Swipe Details
          </MenuItem>
          <MenuItem component={Link} to="/basicDetails" onClick={handleClose}>
            {/* Profile */}
            <ListItemIcon></ListItemIcon>
            Profile
          </MenuItem>
          <MenuItem component={Link} to="/changePassword" onClick={handleClose}>
            <ListItemIcon></ListItemIcon>
            Change Password
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon></ListItemIcon>
            Logout
          </MenuItem>
        </Menu>

        <Menu
          anchorEl={submenuAnchorEl}
          id="accounts-menu"
          open={submenuopen}
          // onClose={handleClose}
          onClick={handleSubmenuClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                // overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                // mt: 1.5,
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: theme.palette.primary.main, // Scroll thumb color
                  borderRadius: "999px",
                },
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "top" }}
        >
          <MenuItem>Role Type</MenuItem>
          <Divider />
          {roles?.map((item, index) => (
            <MenuItem key={index} onClick={(e) => handlerole(item)}>
              <ListItemIcon>{item}</ListItemIcon>
            </MenuItem>
          ))}
        </Menu>

        {/* swipe deatils */}
        {swipemodal && (
          <DialogForm
            position={"top"}
            open={swipemodal}
            setOpen={setSwipeModal}
            width="md"
            fullWidth
            title="Swipe Details"
          >
            <Box>
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: { xs: 2, sm: 3 },
                      mb: 2,
                    }}>
                    <Typography variant="subtitle1">
                      Date : {dayjs().format("DD-MMM-YYYY")}
                    </Typography>

                    {/* Productive Hours */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexDirection: "column",
                      }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color: "#666",
                            fontSize: "12px",
                          }}>
                          💼 Productive Hours
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            color: "#17A34C",
                          }}>
                          {calculatedProductiveProgress}%
                        </Typography>
                        <Box
                          sx={{
                            width: 60,
                            height: 6,
                            backgroundColor: "#e0e0e0",
                            borderRadius: 3,
                            overflow: "hidden",
                          }}>
                          <Box
                            sx={{
                              width: `${calculatedProductiveProgress}%`,
                              height: "100%",
                              backgroundColor: "#17A34C",
                              borderRadius: 3,
                            }}
                          />
                        </Box>
                      </Box>

                      {timeRemaining && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#17A34C",
                            fontSize: "11px",
                            fontWeight: "bold",
                          }}>
                          {timeRemaining} / 08h 00m 00s Expected
                        </Typography>
                      )}
                    </Box>

                    {/* Office Hours Progress */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexDirection: "column",
                      }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color: "#666",
                            fontSize: "12px",
                          }}>
                          🏢 Office Hours
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: calculatedOfficeProgress >= 100 ? "#17A34C" : "#4280EF",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}>
                          {calculatedOfficeProgress}%
                        </Typography>
                        <Box
                          sx={{
                            width: 60,
                            height: 6,
                            backgroundColor: "#e0e0e0",
                            borderRadius: 3,
                            overflow: "hidden",
                          }}>
                          <Box
                            sx={{
                              width: `${calculatedOfficeProgress}%`,
                              height: "100%",
                              backgroundColor: calculatedOfficeProgress >= 100 ? "#17A34C" : "#4280EF",
                              borderRadius: 3,
                            }}
                          />
                        </Box>
                      </Box>

                      {officeHoursRemaining && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: calculatedOfficeProgress >= 100 ? "#17A34C" : "#4280EF",
                            fontSize: "11px",
                            fontWeight: "bold",
                          }}>
                          {officeHoursRemaining}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <CommonDataTable
                    columns={columns}
                    rows={rowData}
                    checkbox={false}
                    search={false}
                    showEntriesBottom={true}
                  />
                </>
              )}
            </Box>
          </DialogForm>
        )}

        <DialogForm
          open={searchmodal}
          setOpen={setSearchModal}
          width={"sm"}
          title={
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <SearchIcon />
              {/* <TextField fullWidth
           id="input-with-icon-textfield"
          //  label="TextField"
          placeholder="Search here"
           onChange={(e)=>handleSearchBar(e.target.value)}
           variant="standard"
         /> */}
              <ThemeProvider theme={themeinput}>
                <InputBase
                  inputRef={searchInput}
                  sx={{ ml: 1, flex: 1, color: "white" }}
                  onChange={(e) => handleSearchBar(e.target.value)}
                  placeholder="What are you looking"
                  inputProps={{ "aria-label": "What are you looking" }}
                />
              </ThemeProvider>
            </Box>
          }
          scroll="paper"
          children={
            <>
              <Grid container rowSpacing={1}>
                {searchlist && Object.keys(searchlist).length > 0 ? (
                  <List sx={{ width: "100%" }}>
                    {Object.entries(searchlist).map(([key, values]) => (
                      <>
                        <ListSubheader>
                          {" "}
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              textTransform: "uppercase",
                            }}
                          >
                            {" "}
                            {key}{" "}
                          </Typography>{" "}
                        </ListSubheader>
                        {values?.map((item) => (
                          <ListItem
                            onClick={handleSearch}
                            sx={(theme) => listItemStyles(theme)}
                            component={Link}
                            to={item.path}
                          >
                            <ListItemText primary={item.text} />
                          </ListItem>
                        ))}
                        {/* </ListItem> */}
                      </>
                    ))}
                  </List>
                ) : (
                  <Grid item xs={12}>
                    <Box justifyItems={"center"}>
                      <SearchOffOutlinedIcon fontSize="large" />
                      <Typography>No Result found</Typography>
                    </Box>
                  </Grid>
                )}

                {/* {searchlist?.length>0 ? (searchlist?.map((item,index)=>(
     
        <Grid item xs={6}>
        <Button variant="outlined" component={Link} key={index}  to={item.path} onClick={handleSearch}> {item?.main ? `${item.main}/` : ""}{item.text}</Button>
      </Grid>
       ))):
       (<Grid item xs={12} justifyItems={"center"}><Typography >No data found</Typography></Grid>)} */}
              </Grid>

              <CustomAlert
                open={orgmodal}
                title="Organization"
                message="Are you sure you want to change Organization?"
                onCancel={() => setOrgModal(!orgmodal)}
                onSubmit={handleOrgType}
                cancelText="Close"
                submitText="Submit"
              />
            </>
          }
        />
      </AppBar>
    </>
  );
};

export default AppBarComponent;
